<template>
  <div>
    <a-card
        :loading="loading"
        :tab-list="getTabs"
        :active-tab-key="tab"
        @tabChange="key => this.tab = key"
    >
      <a slot="tabBarExtraContent" @click="generatePDF">Genereer pdf</a>
      <div v-if="tab === 'car'">
        <div v-for="request in getCarInsuranceComparisonResults" style="margin-top:2em;">
          <div style="display:flex;justify-content: space-between;align-items: center; margin-top: 1em; margin-bottom: 1em;">
            <PolicyDescriptionComponent :policy-id="request.policy_id"></PolicyDescriptionComponent>
            <a-button :href="`/web_api/v1/compare/car/link/${request.policy_id}`" type="link">
              Ga naar polis
            </a-button>
            <span>
              {{ moment(request.created_at).fromNow() }} opgeslagen
            </span>
          </div>
          <a-table
              :data-source="request.responses"
              :pagination="false"
              row-key="id"
              :columns="[
            {
              title: 'Logo',
              dataIndex: 'logo',
              key: 'logo',
              scopedSlots: { customRender: 'logo'}
            },
            {
              title: 'Maatschappijnaam',
              dataIndex: 'Maatschappijnaam',
              key: 'Maatschappijnaam',
            },
            {
              title: 'Huidige premie',
              dataIndex: 'CurrentPremiumAmount',
              key: 'CurrentPremiumAmount',
              scopedSlots: { customRender: 'CurrentPremiumAmount'}
            },
            {
              title: 'Premiebedrag',
              dataIndex: 'Premiebedrag',
              key: 'Premiebedrag',
              scopedSlots: { customRender: 'Premiebedrag'}
            },
            {
              title: 'Besparing',
              dataIndex: 'Besparing',
              key: 'Besparing',
              scopedSlots: { customRender: 'Besparing'}
            },
        ]"
          >
        <span slot="logo" slot-scope="text, record">
            <lazy-component>
              <object :data="`/web_api/v1/compare/car/images/${record.Productid}`"
                      type="image/png"
                      style="width:100px">
                Geen afbeelding beschikbaar
              </object>
            </lazy-component>
        </span>
            <span slot="Premiebedrag" slot-scope="text">
          € {{ text }}
        </span>
            <span slot="CurrentPremiumAmount">
          € {{ getTotalTermAmount('car', request.id) }}
        </span>
            <span slot="Besparing" slot-scope="text,record" :class="(getTotalTermAmount('car', request.id ) - record.Premiebedrag) > 0 ? 'text-success' : 'text-danger' ">
          € {{ (getTotalTermAmount('car', request.id) - record.Premiebedrag).toFixed(2) }}
        </span>
          </a-table>
        </div>
      </div>
      <div v-if="tab === 'death'">
        <div v-for="request in getDeathInsuranceComparisonResults">
          <div style="display:flex;justify-content: space-between;align-items: center; margin-top: 1em; margin-bottom: 1em;">
            <PolicyDescriptionComponent :policy-id="request.policy_id"></PolicyDescriptionComponent>
            <a-button :href="`/web_api/v1/compare/death/link/${request.policy_id}`" type="link">
              Ga naar polis
            </a-button>
            <span>
              {{ moment(request.created_at).fromNow() }} opgeslagen
            </span>
          </div>
          <a-table
              :data-source="request.responses"
              :pagination="false"
              row-key="id"
              :columns="[
            {
              title: 'Logo',
              key: 'logo',
              dataIndex: 'logo',
              scopedSlots: { customRender: 'logo'}
            },
            {
              title: 'Aanbieder',
              key: 'provider',
              dataIndex: 'provider',
            },
            {
              title: 'Huidige premie per maand',
              key: 'current_premium_amount',
              dataIndex: 'current_premium_amount',
              scopedSlots: { customRender: 'current_premium_amount'}
            },
            {
              title: 'Premie per maand',
              key: 'premium_amount',
              dataIndex: 'premium_amount',
              scopedSlots: { customRender: 'premium_amount'}
            },
            {
              title: 'Besparing',
              key: 'besparing',
              dataIndex: 'besparing',
              scopedSlots: { customRender: 'besparing'}
            },
        ]"
          >
            <span slot="logo" slot-scope="text, record">
              <lazy-component>
                <!-- TODO: gebruik link van de lender als dit in de transformer is geïmplementeerd -->
                <object :data="`/img/agency_logos/${record.hdn_code_product_mij_type}.svg`" type="image/png"
                        style="width:100px">
                  Geen afbeelding beschikbaar
                </object>
              </lazy-component>
            </span>
            <span slot="premium_amount" slot-scope="text">
              € {{ text }}
            </span>
            <span slot="current_premium_amount">
              € {{ getTotalTermAmount('death', request.id) }}
            </span>
            <span slot="besparing" slot-scope="text,record" :class="(getTotalTermAmount('death', request.id ) - record.premium_amount) > 0 ? 'text-success' : 'text-danger' ">
          € {{ (getTotalTermAmount('death', request.id) - record.premium_amount).toFixed(2) }}
        </span>
          </a-table>
        </div>
      </div>
      <div v-if="tab === 'mortgage'">
        <div v-for="request in getMortgageRefinanceComparisonResults">
          <div style="display:flex;justify-content: space-between;align-items: center; margin-top: 1em; margin-bottom: 1em;">
            <h5 v-html="sanitizeAddress(request.address)"></h5>
            <a-button :href="`/web_api/v1/compare/mortgage/link/${request.mortgage_id}`" type="link">
              Ga naar hypotheek
            </a-button>
            <span>
              {{ moment(request.created_at).fromNow() }} opgeslagen
            </span>
          </div>
          <a-table
              :data-source="request.responses"
              :pagination="false"
              row-key="id"
              :columns="[
             {
              title: 'Logo',
              key: 'logo',
              dataIndex: 'logo',
              scopedSlots: { customRender: 'logo'}
            },
            {
              title: 'Product',
              key: 'lender_name',
              dataIndex: 'lender_name',
              scopedSlots: { customRender: 'lender_name'}
            },
            {
              title: 'Huidige bruto maandlasten',
              key: 'current_monthly_amount',
              dataIndex: 'current_monthly_amount',
              scopedSlots: { customRender: 'current_monthly_amount'}
            },
            {
              title: 'Bruto maandlasten (na oversluiten)',
              key: 'gross_monthly_mortgage_payments',
              dataIndex: 'gross_monthly_mortgage_payments',
              scopedSlots: { customRender: 'gross_monthly_mortgage_payments'}
            },
            {
              title: 'Totaal verschil maandlasten',
              key: 'total_gross_mortgage_payments_difference',
              dataIndex: 'total_gross_mortgage_payments_difference',
              scopedSlots: { customRender: 'total_gross_mortgage_payments_difference'}
            },
            {
              title: 'Oversluitkosten',
              key: 'total_one_time_refinance_costs',
              dataIndex: 'total_one_time_refinance_costs',
              scopedSlots: { customRender: 'total_one_time_refinance_costs'}
            },
            {
              title: 'Totale besparing',
              key: 'total_gross_refinance_difference',
              dataIndex: 'total_gross_refinance_difference',
              scopedSlots: { customRender: 'total_gross_refinance_difference'}
            }
        ]"
          >
            <span slot="logo" slot-scope="text, record">
              <lazy-component>
                <!-- TODO: gebruik link van de lender als dit in de transformer is geïmplementeerd -->
                <object :data="`/img/agency_logos/${record.lender_id}.png`" type="image/png"
                        style="width:100px">
                  Geen afbeelding beschikbaar
                </object>
              </lazy-component>
            </span>
            <span slot="lender_name" slot-scope="text, record">
              {{ text }}<br><small>{{ record.productLineName }}
            </small>
            </span>
            <span slot="current_monthly_amount">
              € {{ getTotalTermAmount('mortgage', request.id) }}
            </span>
            <span slot="gross_monthly_mortgage_payments" slot-scope="text">
              € {{ text }}
            </span>
            <span slot="total_gross_mortgage_payments_difference" slot-scope="text">
              € {{ text }}
            </span>
            <span slot="total_one_time_refinance_costs" slot-scope="text">
              € {{ text }}
            </span>
            <span slot="total_gross_refinance_difference" slot-scope="text">
              <span :class="text > 0 ? 'text-success':'text-danger'">€ {{ text }}</span>
            </span>
          </a-table>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import compareApi from '~/api/compare.js';
import PolicyDescriptionComponent from "../policy/components/PolicyDescriptionComponent";
import moment from 'moment';
import DOMPurify from 'dompurify';

export default {
  name: 'ComparisonSummary',
  props: {
    customerId: Number,
    canUseTopicusCompareCalculators: Boolean,
    canUseRollsCompareCalculators: Boolean,
  },
  components: {
    PolicyDescriptionComponent
  },
  data() {
    return {
      summary: null,
      loading: false,
      loadingPDF: false,
      tab: 'car',
      moment: moment,
      topicusTabs: [
        {
          key: 'car',
          tab: 'Autoverzekering'
        }
      ],
      rollsTabs: [
        {
          key: 'death',
          tab: 'Overlijdensrisicoverzekering'
        },
        {
          key: 'mortgage',
          tab: 'Hypotheek'
        },
      ]
    }
  },
  mounted() {
    this.fetchComparisonSummary();
  },
  methods: {
    async fetchComparisonSummary() {
      try {
        this.loading = true;
        this.summary = (await compareApi.getCompareSummary(this.customerId)).data;
      } catch (e) {
        this.$notification['warning']({
          message: 'Er ging iets mis met het ophalen van de vergelijkingsuitslagen.'
        })
      } finally {
        this.loading = false;
      }
    },
    async generatePDF() {
      try {
        this.loadingPDF = true;
        let response = await compareApi.getCompareSummaryPDF(this.customerId);
        const url = window.URL.createObjectURL(new Blob([Buffer.from(response.data, 'base64')], {type: 'application/pdf'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `vergelijkingsuitslagen.pdf`); //or any other extension
        document.body.appendChild(link);
        link.click();

      } catch (e) {
        this.$notification['warning']({
          message: 'Er ging iets mis met het downloaden van de pdf.'
        })
      } finally {
        this.loadingPDF = false;
      }
    },
    sortBy(result, key, direction = 'desc') {
      return result.sort((a, b) => {
        if (a.hasOwnProperty(key) && b.hasOwnProperty(key)) {
          return direction === 'desc' ? b[key] - a[key] : a[key] - b[key];
        } else {
          return 1;
        }
      })
    },
    getTotalTermAmount(type, requestId) {
      if (!this.summary.hasOwnProperty(type)) return null;

      let requests = this.summary[type].find(request => request.id === requestId)

      if (!requests) return null;

      return requests.totalTermAmount;
    },
    sanitizeAddress(address) {
      return DOMPurify.sanitize(address);
    }
  },
  computed: {
    getCarInsuranceComparisonResults() {
      if (!this.summary || !Array.isArray(this.summary.car)) return [];

      return this.summary.car.map(request => {
        let responses = this.sortBy(request.car_insurance_comparison_responses, 'Premiebedrag', 'asc');

        request.responses = responses.slice(0, 5);
        return request;
      })
    },
    getDeathInsuranceComparisonResults() {
      if (!this.summary || !Array.isArray(this.summary.death)) return [];

      return this.summary.death.map(request => {
        let responses = this.sortBy(request.death_insurance_comparison_responses, 'premium_amount', 'asc');

        request.responses = responses.slice(0, 5);
        return request;
      })
    },
    getMortgageRefinanceComparisonResults() {
      if (!this.summary || !Array.isArray(this.summary.death)) return [];

      return this.summary.mortgage.map(request => {
        let responses = this.sortBy(request.refinance_comparison_responses, 'total_gross_refinance_difference');

        request.responses = responses.slice(0, 5);
        return request;
      })
    },
    getTabs() {
      let tabs = [];

      if (this.canUseTopicusCompareCalculators) {
        tabs = tabs.concat(this.topicusTabs)
      }

      if (this.canUseRollsCompareCalculators) {
        tabs = tabs.concat(this.rollsTabs)
      }

      return tabs;
    }
  }
}
</script>

<style scoped>

</style>
